import { ERROR_KINDS } from './hooks/useCreateTranslation';

export const VIDEO_CONTAINER_MIN_WIDTH = 290;
export const VIDEO_CONTAINER_MAX_WIDTH = 350;
export const VIDEO_HEIGHT = 240;
export const GAP = 24;
export const SKELETON_COUNT = 7;
export const ONE_COLUMN_BREAKPOINT = 928;
export const GRID_PADDING_COUNT = 20;
export const MIN_DURATION_SECONDS = 10;
export const MAX_DURATION_SECONDS = 5 * 60;
export const NEW_MAX_DURATION_SECONDS = 30 * 60;
export const MAX_FILE_SIZE_MB = 2000;
export const ORIGINAL_TRANSLATION_ID = 'trs_original_id';
export const ORIGINAL = 'Original';
export const DEFAULT_GROUP_TRANSLATION_ERROR = 'Something went wrong';

export const ERROR_TEXT_BY_KIND: Record<ERROR_KINDS, string> = {
    [ERROR_KINDS.CelebrityDetectedError]: 'Famous figure detected',
    [ERROR_KINDS.TextModerationError]: 'Content flagged for moderation',
    [ERROR_KINDS.FaceError]: 'No face detected in your uploaded footage',
};
